/**
 * Utility functions for detecting social media platforms from URLs
 */

export type SocialPlatform = 'tiktok' | 'instagram' | 'other';

/**
 * Detects the social media platform from a URL
 * @param url - The URL to check
 * @returns The detected platform ('tiktok', 'instagram', or 'other')
 */
export function detectSocialPlatform(url: string): SocialPlatform {
  if (url.includes('tiktok.com')) return 'tiktok';
  if (url.includes('instagram.com')) return 'instagram';
  return 'other';
}
